<template>
  <div class="bg-beige-lighter pt-4 pl-4">
    <p @click="$store.dispatch('drawer/close')" class="btn-close">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-body-lighter"><path fill-rule="evenodd" d="m17.9230769 5 1.0769231 1.07692308-5.9240428 5.92278132 5.9240428 5.9233725-1.0769231 1.0769231-5.9233725-5.9240428-5.92278132 5.9240428-1.07692308-1.0769231 5.9224363-5.9233725-5.9224363-5.92278132 1.07692308-1.07692308 5.92278132 5.9224363z"></path>
      </svg>
    </p>
    <ul class="place-list flex overflow-x-scroll mt-4">
      <template v-if="loading">
        <li v-for="n in dummies" v-bind:key="n">
          <place-loading />
        </li>
      </template>
      <template v-else>
        <li v-for="duration in durations" v-bind:key="duration.place.id">
          <place :duration="duration" />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Place from './Place'
import PlaceLoading from './PlaceLoading'
import _ from 'lodash'

export default {
  components: {
    Place,
    PlaceLoading
  },
  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      durations: 'map/getDurations'
    }),
    dummies: function () {
      return _.range(10)
    }
  },
  watch: {
    durations: function (val) {
      if (val.length > 0) {
        this.loading = false
      } else {
        this.loading = true
      }
    }
  }
}
</script>
